import { jsx } from "react/jsx-runtime";
import { pluginLinkViewer, pluginLineSpacingViewer, pluginIndentViewer } from "@wix/ricos";
import "@wix/ricos/css/plugin-collapsible-list-viewer.global.css";
import "@wix/ricos/css/plugin-link-viewer.global.css";
import classNames from "classnames";
import React__default from "react";
import { useConfig } from "../../contexts/config-context.js";
import { useWixRicosViewer } from "../../contexts/ricos-viewer-context.js";
import { htmlAttributesPlugin } from "./ricos-html-attributes-plugin.js";
import styles from "./ricos-viewer.module.scss";
const RicosViewer = ({
  content,
  className,
  customTheme,
  dataHook = "ricos-viewer"
}) => {
  const WixRicosViewer = useWixRicosViewer();
  const { language, baseUrl } = useConfig();
  if (!content) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames(styles.container, className),
      "data-hook": dataHook,
      children: /* @__PURE__ */ jsx(
        WixRicosViewer,
        {
          baseUrl,
          biSettings: {
            consumer: "Forms",
            platform: "Livesite",
            postId: "",
            containerId: ""
          },
          instance: "",
          theme: customTheme,
          content,
          plugins: [
            htmlAttributesPlugin(),
            pluginLinkViewer(),
            pluginLineSpacingViewer(),
            pluginIndentViewer()
          ],
          locale: language
        }
      )
    }
  );
};
const RicosViewer$1 = React__default.memo(RicosViewer);
export {
  RicosViewer$1 as default
};
//# sourceMappingURL=ricos-viewer.js.map
